// Sidebar route metadata
export class SidebarItem {
  path: string;
  title: string;
  icon: string;
  class: string;
  badge: string;
  badgeClass: string;
  isExternalLink: boolean;
  submenu : SidebarItem[];
}
